var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoiceIconWithGrayBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35,
    r: 35,
    fill: "#ECF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0664 22.1431V27.8574C38.0664 28.2362 38.2169 28.5996 38.4848 28.8675C38.7527 29.1354 39.1161 29.2859 39.495 29.2859H45.2093",
    stroke: "#3E556D",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3538 47.8574H28.0681C27.3103 47.8574 26.5836 47.5563 26.0478 47.0205C25.512 46.4847 25.2109 45.758 25.2109 45.0002V25.0002C25.2109 24.2424 25.512 23.5157 26.0478 22.9799C26.5836 22.4441 27.3103 22.1431 28.0681 22.1431H38.0681L45.2109 29.2859V45.0002C45.2109 45.758 44.9099 46.4847 44.3741 47.0205C43.8383 47.5563 43.1116 47.8574 42.3538 47.8574Z",
    stroke: "#3E556D",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9258 27.8579H32.3544",
    stroke: "#3E556D",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9258 36.4302H39.4972",
    stroke: "#3E556D",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6406 42.1416H39.4978",
    stroke: "#3E556D",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIconWithGrayBg);
export default __webpack_public_path__ + "static/media/InvoiceIconWithGrayBg.227b0123ee133c1967e5ce4e67cbd2e2.svg";
export { ForwardRef as ReactComponent };